var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 607.833,
    height: 905.914,
    viewBox: "0 0 607.833 905.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(607.833 905.914) rotate(180)",
    opacity: 0.191
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 125.785,
    cy: 125.785,
    r: 125.785,
    transform: "translate(0 403.073)",
    fill: "#9c2fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M24.98,360.588h224.3V128.352c0-28.193-8.051-56.072-24.532-78.963A118.048,118.048,0,0,0,173.668,8.6C159.077,2.553,143.248,0,127.432,0H77.379V79.406l52.386,1.642s36.022,0,34.381,55.669H24.98Z",
    transform: "translate(7.564)",
    fill: "#9c2fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(315.173 110.842)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 141.054,
    cy: 141.054,
    r: 141.054,
    transform: "translate(5.276)",
    fill: "#9c2fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M241.92,334.22H534.581v303c0,36.791-10.514,73.165-32,103.025-14.774,20.519-36.088,40.556-66.638,53.232-19.06,7.908-39.709,11.23-60.346,11.23H310.278V701.1l68.358-2.137s46.992,0,44.855-72.631H241.92Z",
    transform: "translate(-241.92 -9.641)",
    fill: "#9c2fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.2f2cf87494b1c6b06b4b8c85c4826176.svg";
export { ForwardRef as ReactComponent };